import { Button } from "@mui/material"
import { useScoreAPI } from "../../score/context/ScoreProvider"

export const UIUnlockChapters = () => {
  const { unlockAllChapters } = useScoreAPI()

  return (
    <>
      {process.env.REACT_APP_DEV_MODE === "true" && (
        <Button onClick={unlockAllChapters} variant="contained" color="error" sx={{ pointerEvents: "auto" }}>
          Unlock All Chapters
        </Button>
      )}
    </>
  )
}
